<template>
    <section class="container-fluid">
      <div class="title-container">
        <h3 class="title">
          Unit management
          <div
            class="spinner-border spinner-theme_default"
            role="status"
            v-if="isLoading"
          >
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </h3>

        <!--<div class="title-container__controls">
          <b-button
            class="button title-container__controls-item"
            :variant="isShowAttach ? 'secondary' : 'info'"
            @click="toggleShowAttach"
          >
            <span class="material-icons icon-image-preview">
              tune
            </span>
            Show Attach
          </b-button>
        </div>-->
      </div>
<!--      <div class="form-theme__primary" v-show="isShowAttach">-->
<!--        <FormGenerator-->
<!--          v-if="$can('create-unit_management')"-->
<!--          textButtonSubmit="Attach"-->
<!--          :data="filters"-->
<!--          :showReset="false"-->
<!--          @submit="attach"-->
<!--        />-->
<!--      </div>-->

      <TableForPage
        v-if="unitForTable.length > 0 && $can('read_own-unit_management')"
        style="margin-bottom: 0;"
        :tableData="unitForTable"
        :fields="fields.unit"
        :slots="table.slots"
        showTopControls
        ref="table"
      >
        <template v-slot:tableControls>
          <FormGenerator
            class="form-horizontal"
            v-if="$can('create-unit_management')"
            textButtonSubmit="Attach"
            :data="filters"
            :showReset="false"
            :isLoading="isLoading"
            @submit="attach"
          />
        </template>
         <template v-slot:name='slotProps'>
            <TableUserItem :user="slotProps.item" :number="slotProps.item.index" />
        </template>
        <template
          v-slot:related_users="slotProps"
        >
          <div class="table-chips-list" v-if="slotProps.item.related_users">
            <div class="table-chips-item" v-for="user in slotProps.item.related_users" :key="user.id">

              {{ user.name }}
              <b-button
                variant="icon"
                class="table-chips-item__button-detach"
                @click="detach(user)"
              >
                <span class="material-icons">
                  highlight_off
                </span>
              </b-button>
            </div>
          </div>

        </template>
      </TableForPage>
      <div v-else>
       <strong> No data to show </strong>
      </div>
    </section>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'

export default {
  name: 'UnitManagement',
  components: {
    FormGenerator,
    TableForPage,
    TableUserItem
  },
  data () {
    return {
      // isShowAttach: true,
      isLoading: false,
      filters: {
        'unit_manager': {
          type: 'select',
          name: 'unit_manager',
          label: 'Unit manager',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'detached': {
          type: 'select',
          name: 'developer',
          label: 'Detached users',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        }
      },
      accessToken: 'Bearer' + localStorage.getItem('access_token'),
      detached: [],
      unitManagers: [],
      form: {
        unit_manager: '',
        developer: ''
      },
      table: {
        slots: {
          related_users: {
            name: 'related_users'
          },
          name: {
            name: 'name'
          }
        }
      },
      fields: {
        unit: [
          {
            key: 'name',
            label: 'Unit manager',
            sortable: true,
            class: 'column-bd-name'
          },
          {
            key: 'related_users',
            label: 'Attached users',
            sortable: true
          }
        ],
        user: {
          name: {
            label: 'name',
            tdClass: 'col-sm-10'
          },
          detach: {
            label: 'detach',
            tdClass: 'col-sm-2'
          }
        }
      }
    }
  },
  computed: {
    unitForTable () {
      // filter data for table
      return this.unitManagers.filter(manager => manager.related_users.length !== 0).map(manager => {
        return {
          name: manager.name,
          related_users: manager.related_users.map(user => {
            user.unitManager = manager.id
            return user
          })
        }
      })
    }
  },
  methods: {
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        const value = field['value']
        data[name] = typeof value === 'object' ? value[field['valueField']] : value
      }

      return data
    },
    attach (fields) {
      const dataForRequest = this.prepareDataForGetReports(fields)
      this.isLoading = true

      this.axios.post('api/attach-user', dataForRequest, { headers: { Authorization: this.accessToken } })
        .then(response => response.data)
        .then(() => {
          let manager = this.unitManagers.find(manager => manager.id === dataForRequest.unit_manager)
          let user = this.detached.find(user => user.id === dataForRequest.developer)
          this.detached.splice(this.detached.indexOf(user), 1)
          this.filters.detached.options.splice(this.detached.indexOf(user), 1)
          user.unitManager = manager.id
          manager.related_users.push(user)
          this.$snotify.success('User successfully attached', 'Success', this.$store.state.snotify)
        }).finally(() => {
          this.isLoading = false
        })
    },
    async detach (user) {
      const confirm = await this.$refs.table.$refs.confirm.open(
        'Сonfirmation',
        `Are you sure you want to detach <b>${user.name}</b> ?`,
        { submitText: 'Yes, delete' }
      )

      if (!confirm) return

      let requestData = {
        unit_manager: user.unitManager,
        developer: user.id
      }
      this.isLoading = true

      this.axios.post('api/detach-user', requestData, { headers: { Authorization: this.accessToken } })
        .then(response => response.data)
        .then(() => {
          let unit = this.unitManagers.find(manager => manager.id === requestData.unit_manager)
          unit.related_users = unit.related_users.filter(unitUser => unitUser.id !== user.id)
          delete user.unitManager
          this.detached.push(user)
          this.$snotify.success('User successfully detached', 'Success', this.$store.state.snotify)
        }).finally(() => {
          this.isLoading = false
        })
    }
  },
  mounted () {
    this.axios.get('api/users_for_unit', { headers: { Authorization: this.accessToken } })
      .then(response => response.data)
      .then(users => {
        this.unitManagers = users.managers_with_attached
        this.detached = users.detached
        this.filters.unit_manager.options = users.managers_with_attached
        this.filters.detached.options = users.detached
      })
      .catch(exception => console.log(exception.message))
  }
}
</script>

<style>
    .hidden-header {
        display: none !important;
    }

    .related-users-cell {
        padding: 0 !important;
    }

    .related-user-table table {
        margin-bottom: 0;
    }
</style>
